import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  commentCount: number;
  isExpanded: boolean;
  onToggle: () => void;
};

export const PostFooter = ({ commentCount, isExpanded, onToggle }: Props) => (
  <div className="flex flex-row items-center justify-between">
    <button
      type="button"
      onClick={onToggle}
      className="text-[0.6rem] font-extrabold uppercase leading-[0.875rem] text-[#2C3548]"
    >
      {commentCount === 1 ? '1 comment' : `${commentCount} comments`}
    </button>
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-2 px-4 py-2 text-base text-[#5F1ECC]"
    >
      {!isExpanded && <FontAwesomeIcon icon={faPlus} />}
      <span>{isExpanded ? 'Hide comments' : 'Comment'}</span>
    </button>
  </div>
);
